// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDarregmgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDarregmgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDarregmgrIconOutlined = function DrrpDarregmgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDarregmgrIconOutlinedSvg
  }));
};

DrrpDarregmgrIconOutlined.displayName = 'DrrpDarregmgrIconOutlined';
export default React.forwardRef(DrrpDarregmgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDarregmgrIconOutlined.js
// module id = 2534
// module chunks = 0